function getAge(liga, nacimiento) {
    if (!liga || !nacimiento) return "-";
    const yearMatch = String(liga).match(/(\d{4})/);
    const birthYear = new Date(nacimiento).getFullYear();

    if (!yearMatch || Number.isNaN(birthYear)) return "-";
    return Number(yearMatch[1]) - birthYear;
}

function getValue(item, keys, fallback = 0) {
    if (!item) return fallback;
    const keyList = Array.isArray(keys) ? keys : [keys];
    const foundKey = keyList.find((key) => item[key] !== undefined && item[key] !== null);
    return foundKey ? item[foundKey] : fallback;
}

function getDoubleDoubleCount(dobleDoble) {
    if (typeof dobleDoble === "number") return dobleDoble;
    if (!dobleDoble) return 0;
    return (dobleDoble.ptsReb || 0) + (dobleDoble.ptsAst || 0);
}

function getTripleDoubleCount(tripleDoble) {
    if (typeof tripleDoble === "number") return tripleDoble;
    if (!tripleDoble || typeof tripleDoble !== "object") return 0;

    return Object.values(tripleDoble).reduce((total, value) => {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? total + numericValue : total;
    }, 0);
}

function isInternationalLeague(item) {
    if (!item) return false;

    const liga = String(item.liga || "").toUpperCase();
    return !liga.includes("LUB");
}

function TableColumnsHeader({ sectionTitle }) {
    return (
        <tr className="bg-[#102216] text-xs md:text-sm uppercase tracking-wider text-slate-500 border-y border-white/10">
            <th className="px-4 py-2.5 text-left">{sectionTitle}</th>
            <th className="px-2 py-2.5 text-center">Edad</th>
            <th className="px-2 py-2.5 text-center">Min</th>
            <th className="px-2 py-2.5 text-center">Pts</th>
            <th className="px-2 py-2.5 text-center">RO</th>
            <th className="px-2 py-2.5 text-center">RD</th>
            <th className="px-2 py-2.5 text-center">RT</th>
            <th className="px-2 py-2.5 text-center">AS</th>
            <th className="px-2 py-2.5 text-center">TC H</th>
            <th className="px-2 py-2.5 text-center">TC L</th>
            <th className="px-2 py-2.5 text-center">2PTS H</th>
            <th className="px-2 py-2.5 text-center">2PTS L</th>
            <th className="px-2 py-2.5 text-center">3PTS H</th>
            <th className="px-2 py-2.5 text-center">3PTS L</th>
            <th className="px-2 py-2.5 text-center">1PTS H</th>
            <th className="px-2 py-2.5 text-center">1PTS L</th>
            <th className="px-2 py-2.5 text-center">PER</th>
            <th className="px-2 py-2.5 text-center">ROB</th>
            <th className="px-2 py-2.5 text-center">BLQ</th>
            <th className="px-2 py-2.5 text-center">FP</th>
            <th className="px-2 py-2.5 text-center">DBL-DBL</th>
            <th className="px-2 py-2.5 text-center">TPL-DBL</th>
        </tr>
    );
}

function TotalRow({ item, nacimiento, onLeagueClick }) {
    return (
        <tr className="hover:bg-white/5 transition-colors">
            <td className="px-4 py-2.5 font-medium text-green-400">
                <button
                    type="button"
                    onClick={() => onLeagueClick?.(item.liga)}
                    className="hover:underline"
                >
                    {item.liga}
                </button>
            </td>
            <td className="px-2 py-2.5 text-center">{getAge(item.liga, nacimiento)}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["min"] )}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["pts"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["ro"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["rd"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["rt"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["ast"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["tch", "camposHechos"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["tcl", "camposIntent"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["tdh", "doblesHechos"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["tdl", "doblesIntent"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["tth", "triplesHechos"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["ttl", "triplesIntent"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["tlh", "libresHechos"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["tll", "libresIntent"])}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["to"] )}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["stl"] )}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["bls"] )}</td>
            <td className="px-2 py-2.5 text-center">{getValue(item, ["fls"] )}</td>
            <td className="px-2 py-2.5 text-center font-bold">{getDoubleDoubleCount(item.dobleDoble)}</td>
            <td className="px-2 py-2.5 text-center font-bold">{getTripleDoubleCount(item.tripleDoble)}</td>
        </tr>
    );
}

export default function JugadorTotalsTable({ totals = [], careerTotals, nacimiento, onLeagueClick, isCollapsed = false, onToggleCollapse }) {
    if (!totals.length) {
        return null;
    }

    const localTotals = totals.filter((item) => !isInternationalLeague(item));
    const internationalTotals = totals.filter((item) => isInternationalLeague(item));
    const localLeaguesCount = localTotals.length;
    const internationalLeaguesCount = internationalTotals.length;

    return (
        <section className="mb-12">
            <div className={`flex items-center justify-between gap-3 border border-white/10 bg-[#102216] px-4 py-1.5 ${isCollapsed ? "rounded-lg" : "rounded-t-lg"}`}>
                <h3 className="text-base md:text-lg font-bold text-slate-200">Totales</h3>
                <button
                    type="button"
                    onClick={onToggleCollapse}
                    className="text-xs font-semibold uppercase tracking-wide text-slate-300 transition-colors hover:text-green-400"
                >
                    {isCollapsed ? "Mostrar" : "Ocultar"}
                </button>
            </div>
            <div className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${isCollapsed ? "grid-rows-[0fr] opacity-0" : "grid-rows-[1fr] opacity-100"}`}>
                <div className="min-h-0 overflow-hidden">
                    <div className="-mt-px overflow-x-auto rounded-b-xl border-x border-b border-white/10 bg-[#102216] relative">
                        <p className="sm:hidden text-[10px] text-slate-500 text-right px-3 py-1 sticky top-0 left-0 z-20 w-fit ml-auto pointer-events-none">Desliza para ver más →</p>
                        <table className="table-auto w-max min-w-full text-left text-xs sm:text-sm">
                    <thead>
                        <tr className="bg-[#102216] text-xs md:text-sm font-bold uppercase tracking-wider text-slate-500 border-b border-white/10">
                            <th className="px-4 py-3">Liga ({localLeaguesCount})</th>
                            <th className="px-2 py-3 text-center">Edad</th>
                            <th className="px-2 py-3 text-center">Min</th>
                            <th className="px-2 py-3 text-center">Pts</th>
                            <th className="px-2 py-3 text-center">RO</th>
                            <th className="px-2 py-3 text-center">RD</th>
                            <th className="px-2 py-3 text-center">RT</th>
                            <th className="px-2 py-3 text-center">AS</th>
                            <th className="px-2 py-3 text-center">TC H</th>
                            <th className="px-2 py-3 text-center">TC L</th>
                            <th className="px-2 py-3 text-center">2PTS H</th>
                            <th className="px-2 py-3 text-center">2PTS L</th>
                            <th className="px-2 py-3 text-center">3PTS H</th>
                            <th className="px-2 py-3 text-center">3PTS L</th>
                            <th className="px-2 py-3 text-center">1PTS H</th>
                            <th className="px-2 py-3 text-center">1PTS L</th>
                            <th className="px-2 py-3 text-center">PER</th>
                            <th className="px-2 py-3 text-center">ROB</th>
                            <th className="px-2 py-3 text-center">BLQ</th>
                            <th className="px-2 py-3 text-center">FP</th>
                            <th className="px-2 py-3 text-center">DBL-DBL</th>
                            <th className="px-2 py-3 text-center">TPL-DBL</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-white/10 text-slate-300">
                        {localTotals.map((item, index) => (
                            <TotalRow key={`tot-local-${item.liga}-${index}`} item={item} nacimiento={nacimiento} onLeagueClick={onLeagueClick} />
                        ))}

                        {internationalTotals.length > 0 && localTotals.length > 0 ? (
                            <TableColumnsHeader sectionTitle={`Internacional (${internationalLeaguesCount})`} />
                        ) : null}

                        {internationalTotals.map((item, index) => (
                            <TotalRow key={`tot-int-${item.liga}-${index}`} item={item} nacimiento={nacimiento} onLeagueClick={onLeagueClick} />
                        ))}

                        {careerTotals ? (
                            <tr className="bg-green-500/10 font-bold text-slate-100 border-t border-green-400/30">
                                <td className="px-4 py-3 uppercase">Carrera</td>
                                <td className="px-2 py-3 text-center">-</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["min"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["pts"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["ro"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["rd"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["rt"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["ast"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["tch", "camposHechos"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["tcl", "camposIntent"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["tdh", "doblesHechos"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["tdl", "doblesIntent"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["tth", "triplesHechos"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["ttl", "triplesIntent"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["tlh", "libresHechos"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["tll", "libresIntent"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["to"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["stl"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["bls"])}</td>
                                <td className="px-2 py-3 text-center">{getValue(careerTotals, ["fls"])}</td>
                                <td className="px-2 py-3 text-center">{getDoubleDoubleCount(careerTotals.dobleDoble)}</td>
                                <td className="px-2 py-3 text-center">{getTripleDoubleCount(careerTotals.tripleDoble)}</td>
                            </tr>
                        ) : null}
                    </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
}
